
jQuery(document).ready(function($){
    /**********************************************/
    $layerslider = $('#layerslider');
    $layerslidermobile = $('#layerslider-mobile');

    $layerslider.layerSlider({
        // navButtons: true,
        // keybNav: true,
        // autoStart: false,
        responsive: true,
        sliderFadeInDuration: 0,
        twoWaySlideshow: true,
        hoverPrevNext: false,
        pauseOnHover: 'disabled',
        showCircleTimer: false,
        showBarTimer: true,
        allowRestartOnResize: true,
        useSrcset: false,
        thumbnailNavigation: 'disabled',
        navStartStop: false,
        navButtons: false,
        // skin: 'borderlesslight3d',
        // skin: 'v6',
        // skin: 'fullwidth',
        skin: 'noskin',
        //skin: 'numbers', // cool
        // skin: 'outline', // cool too
        // skin: 'borderlessdark3d', // si photo pâle
        // plugins: ['origami'],

        skinsPath: '_sources/vendors/layerslider/skins/',
    });

    $layerslidermobile.layerSlider({

        responsive: true,
        sliderFadeInDuration: 0,
        twoWaySlideshow: true,
        hoverPrevNext: false,
        pauseOnHover: 'disabled',

        navButtons: false,
        navPrevNext: false,
        navStartStop: false,
        hoverPrevNext: false,
        keybNav: false,
        showCircleTimer: false,
        thumbnailNavigation: 'disabled',
        skin: 'noskin',
        //skin: 'numbers', // cool
        // skin: 'outline', // cool too
        // skin: 'borderlessdark3d', // si photo pâle

        skinsPath: '_sources/vendors/layerslider/skins/',
    });

    $(".slideshow-next").click(function () {
        $layerslider.layerSlider('next');
        $layerslidermobile.layerSlider('next');
    });
    $(".slideshow-prev").click(function () {
        $layerslider.layerSlider('prev');
        $layerslidermobile.layerSlider('prev');
    });
});
